import { IntegrationIconProps } from './types';

const Firefox = ({ dimension }: IntegrationIconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.9905 10.7265C28.3816 9.2574 27.1473 7.67139 26.1784 7.17039C26.967 8.72015 27.4232 10.2746 27.5976 11.4344C27.5976 11.4344 27.5976 11.4426 27.6005 11.4578C26.0156 7.49777 23.3277 5.90065 21.1327 2.42407C21.0213 2.24869 20.9105 2.07331 20.802 1.88566C20.7407 1.77985 20.6911 1.68397 20.648 1.59336C20.557 1.41757 20.4867 1.23179 20.4386 1.03975C20.439 1.03063 20.4359 1.02169 20.4301 1.01467C20.4243 1.00765 20.4161 1.00305 20.4071 1.00175C20.3985 0.999416 20.3894 0.999416 20.3808 1.00175C20.3785 1.00281 20.3763 1.00419 20.3744 1.00584C20.3709 1.00584 20.3674 1.00994 20.3639 1.0111L20.3697 1.0035C16.8483 3.07063 15.6536 6.89446 15.544 8.80784C14.1368 8.90428 12.7913 9.42358 11.683 10.298C11.5672 10.1998 11.4461 10.1081 11.3202 10.0232C11.0008 8.9027 10.9873 7.71683 11.2811 6.58931C9.84091 7.24697 8.72095 8.28463 7.90664 9.20303H7.90023C7.34433 8.49742 7.38341 6.17015 7.41491 5.68435C7.40849 5.65395 7.00076 5.89656 6.94826 5.93339C6.45773 6.2841 5.9992 6.67771 5.57805 7.1096C5.0988 7.59655 4.66096 8.12276 4.26909 8.68274C3.36752 9.96323 2.72814 11.4101 2.3879 12.9398C2.38149 12.9702 2.37565 13.0017 2.36924 13.0327C2.34299 13.1561 2.24791 13.7751 2.23099 13.9096V13.9406C2.10704 14.5803 2.02984 15.2282 2 15.8791V15.951C2 23.7097 8.27646 30 16.0182 30C22.9521 30 28.7088 24.9549 29.8364 18.328C29.8597 18.1485 29.8789 17.9673 29.8999 17.786C30.1788 15.3763 29.869 12.8439 28.9905 10.7265ZM12.8327 21.7239C12.8981 21.7549 12.9599 21.7894 13.027 21.8197L13.0363 21.8256C12.9692 21.7929 12.901 21.759 12.8333 21.7239H12.8327ZM27.6017 11.4642V11.4508V11.466V11.4642Z"
      fill="url(#paint0_linear_1334_628)"
    />
    <path
      d="M28.9907 10.7265C28.3818 9.25741 27.1475 7.67141 26.1786 7.17041C26.9672 8.72017 27.4234 10.2746 27.5978 11.4344V11.4631C28.9208 15.0572 28.1998 18.7121 27.1615 20.9452C25.555 24.4002 21.6661 27.9416 15.578 27.7692C9.00581 27.5821 3.21175 22.6885 2.1297 16.2842C1.93254 15.2735 2.1297 14.7608 2.22886 13.9406C2.10812 14.5725 2.06203 14.7555 2.00195 15.8791V15.951C2.00195 23.7098 8.27842 30 16.0202 30C22.954 30 28.7108 24.9549 29.8383 18.328C29.8616 18.1485 29.8809 17.9673 29.9019 17.7861C30.179 15.3764 29.8692 12.8439 28.9907 10.7265Z"
      fill="url(#paint1_radial_1334_628)"
    />
    <path
      d="M28.9907 10.7265C28.3818 9.25741 27.1475 7.67141 26.1786 7.17041C26.9672 8.72017 27.4234 10.2746 27.5978 11.4344V11.4631C28.9208 15.0572 28.1998 18.7121 27.1615 20.9452C25.555 24.4002 21.6661 27.9416 15.578 27.7692C9.00581 27.5821 3.21175 22.6885 2.1297 16.2842C1.93254 15.2735 2.1297 14.7608 2.22886 13.9406C2.10812 14.5725 2.06203 14.7555 2.00195 15.8791V15.951C2.00195 23.7098 8.27842 30 16.0202 30C22.954 30 28.7108 24.9549 29.8383 18.328C29.8616 18.1485 29.8809 17.9673 29.9019 17.7861C30.179 15.3764 29.8692 12.8439 28.9907 10.7265Z"
      fill="url(#paint2_radial_1334_628)"
    />
    <path
      d="M22.1776 12.3774C22.2085 12.399 22.2359 12.4207 22.2651 12.4423C21.9133 11.8162 21.4749 11.2431 20.9631 10.74C16.6058 6.37304 19.821 1.2707 20.3629 1.01114L20.3687 1.00354C16.8473 3.07067 15.6526 6.8945 15.543 8.80788C15.7063 8.79677 15.869 8.78274 16.0353 8.78274C18.6631 8.78274 20.952 10.2314 22.1776 12.3774Z"
      fill="url(#paint3_radial_1334_628)"
    />
    <path
      d="M16.0437 13.2496C16.0209 13.6004 14.7889 14.8047 14.3579 14.8047C10.3715 14.8047 9.72461 17.2214 9.72461 17.2214C9.8996 19.2569 11.3147 20.933 13.0268 21.8198C13.1049 21.8601 13.1837 21.8964 13.2601 21.9326C13.3972 21.9911 13.5348 22.0495 13.6719 22.1016C14.259 22.3091 14.8739 22.4273 15.4959 22.4523C22.4829 22.7809 23.8373 14.0798 18.7946 11.5532C20.0854 11.3281 21.4259 11.849 22.1743 12.3757C20.9493 10.2296 18.6598 8.78101 16.032 8.78101C15.8657 8.78101 15.703 8.79504 15.5397 8.80614C14.1335 8.90378 12.7893 9.42366 11.6822 10.298C11.8963 10.4798 12.1378 10.7219 12.6458 11.2234C13.599 12.1658 16.0384 13.1356 16.0437 13.2496Z"
      fill="url(#paint4_radial_1334_628)"
    />
    <path
      d="M16.0437 13.2496C16.0209 13.6004 14.7889 14.8047 14.3579 14.8047C10.3715 14.8047 9.72461 17.2214 9.72461 17.2214C9.8996 19.2569 11.3147 20.933 13.0268 21.8198C13.1049 21.8601 13.1837 21.8964 13.2601 21.9326C13.3972 21.9911 13.5348 22.0495 13.6719 22.1016C14.259 22.3091 14.8739 22.4273 15.4959 22.4523C22.4829 22.7809 23.8373 14.0798 18.7946 11.5532C20.0854 11.3281 21.4259 11.849 22.1743 12.3757C20.9493 10.2296 18.6598 8.78101 16.032 8.78101C15.8657 8.78101 15.703 8.79504 15.5397 8.80614C14.1335 8.90378 12.7893 9.42366 11.6822 10.298C11.8963 10.4798 12.1378 10.7219 12.6458 11.2234C13.599 12.1658 16.0384 13.1356 16.0437 13.2496Z"
      fill="url(#paint5_radial_1334_628)"
    />
    <path
      d="M11.0321 9.83093C11.1458 9.90459 11.2391 9.96656 11.3237 10.0233C11.0043 8.90275 10.9908 7.71688 11.2846 6.58936C9.84443 7.24702 8.72446 8.28468 7.91016 9.20308C7.97607 9.20132 10.0095 9.16449 11.0321 9.83093Z"
      fill="url(#paint6_radial_1334_628)"
    />
    <path
      d="M2.13068 16.2842C3.21273 22.6885 9.00679 27.5821 15.5837 27.7692C21.6717 27.9416 25.5583 24.4002 27.1671 20.9452C28.2054 18.7115 28.9264 15.0572 27.6034 11.4631V11.4362C27.6034 11.4397 27.6034 11.4444 27.6064 11.4596C28.1033 14.714 26.452 17.8667 23.8702 19.9987C23.8676 20.0047 23.865 20.0108 23.8626 20.0169C18.8316 24.1225 14.0175 22.4938 13.0427 21.8291C12.9751 21.7964 12.9068 21.7625 12.8392 21.7274C9.90568 20.3244 8.69413 17.644 8.95371 15.3471C6.47754 15.3471 5.6329 13.2531 5.6329 13.2531C5.6329 13.2531 7.85649 11.6642 10.7871 13.0462C13.5012 14.3264 16.0503 13.2537 16.0503 13.2531C16.0451 13.1391 13.6056 12.1663 12.6543 11.2269C12.1462 10.7253 11.9047 10.4833 11.6906 10.3015C11.5748 10.2033 11.4537 10.1116 11.3278 10.0267C11.2444 9.96827 11.1528 9.90981 11.0361 9.8344C10.0136 9.16796 7.98016 9.20479 7.91307 9.20654H7.90666C7.35076 8.50094 7.38984 6.17367 7.42134 5.68787C7.41492 5.65747 7.00719 5.90008 6.95469 5.93691C6.46416 6.28761 6.00563 6.68122 5.58448 7.11311C5.10523 7.60007 4.66739 8.12628 4.27553 8.68625C3.37395 9.96675 2.73457 11.4136 2.39434 12.9433C2.38325 12.9702 1.88452 15.1525 2.13068 16.2842Z"
      fill="url(#paint7_radial_1334_628)"
    />
    <path
      d="M20.9634 10.7399C21.4752 11.2431 21.9135 11.8162 22.2653 12.4423C22.3383 12.4971 22.4083 12.5557 22.4753 12.6176C25.6532 15.55 23.9908 19.7012 23.8642 19.9993C26.446 17.8673 28.0973 14.7146 27.6003 11.4601C26.0155 7.49777 23.3276 5.90065 21.1325 2.42407C21.0211 2.24869 20.9103 2.07331 20.8018 1.88566C20.7406 1.77985 20.691 1.68397 20.6478 1.59336C20.5569 1.41757 20.4866 1.23179 20.4384 1.03975C20.4388 1.03063 20.4358 1.02169 20.43 1.01467C20.4241 1.00765 20.4159 1.00305 20.4069 1.00175C20.3983 0.999416 20.3893 0.999416 20.3807 1.00175C20.3783 1.00281 20.3762 1.00419 20.3742 1.00584C20.3707 1.00584 20.3672 1.00994 20.3637 1.0111C19.8213 1.27066 16.606 6.37301 20.9634 10.7399Z"
      fill="url(#paint8_radial_1334_628)"
    />
    <path
      d="M22.4743 12.6147C22.4073 12.5528 22.3372 12.4942 22.2643 12.4394C22.2357 12.4177 22.206 12.3961 22.1768 12.3745C21.4284 11.8483 20.088 11.3269 18.7971 11.5519C23.8393 14.0786 22.4854 22.7797 15.4985 22.4511C14.8764 22.4261 14.2616 22.3079 13.6744 22.1004C13.5374 22.0489 13.3997 21.9922 13.2626 21.9314C13.1833 21.8952 13.1045 21.8589 13.0293 21.8186L13.0386 21.8244C14.0133 22.4909 18.8274 24.1196 23.8585 20.0122C23.8585 20.0122 23.8614 20.0046 23.8661 19.9941C23.9909 19.7012 25.6534 15.55 22.4743 12.6147Z"
      fill="url(#paint9_radial_1334_628)"
    />
    <path
      d="M9.72532 17.2214C9.72532 17.2214 10.3722 14.8047 14.3586 14.8047C14.7897 14.8047 16.0216 13.5992 16.0444 13.2497C16.0671 12.9001 13.4953 14.323 10.7811 13.0427C7.85055 11.6607 5.62695 13.2497 5.62695 13.2497C5.62695 13.2497 6.47159 15.3437 8.94776 15.3437C8.68819 17.6405 9.89973 20.3186 12.8332 21.7239C12.8986 21.7549 12.9604 21.7894 13.0275 21.8198C11.3154 20.9347 9.90207 19.2569 9.72532 17.2214Z"
      fill="url(#paint10_radial_1334_628)"
    />
    <path
      d="M28.9905 10.7265C28.3816 9.2574 27.1473 7.67139 26.1784 7.17039C26.967 8.72015 27.4232 10.2746 27.5976 11.4344C27.5976 11.4344 27.5976 11.4426 27.6005 11.4578C26.0156 7.49777 23.3277 5.90065 21.1327 2.42407C21.0213 2.24869 20.9105 2.07331 20.802 1.88566C20.7407 1.77985 20.6911 1.68397 20.648 1.59336C20.557 1.41757 20.4867 1.23179 20.4386 1.03975C20.439 1.03063 20.4359 1.02169 20.4301 1.01467C20.4243 1.00765 20.4161 1.00305 20.4071 1.00175C20.3985 0.999416 20.3894 0.999416 20.3808 1.00175C20.3785 1.00281 20.3763 1.00419 20.3744 1.00584C20.3709 1.00584 20.3674 1.00994 20.3639 1.0111L20.3697 1.0035C16.8483 3.07063 15.6536 6.89446 15.544 8.80784C15.7073 8.79673 15.8701 8.78271 16.0363 8.78271C18.6641 8.78271 20.9531 10.2313 22.1786 12.3774C21.4302 11.8512 20.0898 11.3298 18.7989 11.5549C23.841 14.0815 22.4872 22.7826 15.5002 22.454C14.8782 22.429 14.2633 22.3108 13.6762 22.1033C13.5391 22.0518 13.4015 21.9951 13.2644 21.9343C13.1851 21.8981 13.1063 21.8618 13.0311 21.8215L13.0404 21.8273C12.9727 21.7946 12.9045 21.7607 12.8368 21.7256C12.9021 21.7566 12.964 21.7911 13.0311 21.8215C11.3155 20.9347 9.90216 19.2569 9.72542 17.2213C9.72542 17.2213 10.3723 14.8046 14.3587 14.8046C14.7898 14.8046 16.0217 13.5992 16.0445 13.2496C16.0392 13.1356 13.5998 12.1628 12.6484 11.2234C12.1403 10.7218 11.8988 10.4798 11.6848 10.298C11.5689 10.1998 11.4478 10.1081 11.3219 10.0232C11.0026 8.9027 10.9891 7.71683 11.2829 6.58931C9.84266 7.24697 8.7227 8.28463 7.90839 9.20303H7.90198C7.34608 8.49742 7.38516 6.17015 7.41666 5.68435C7.41024 5.65395 7.00251 5.89656 6.95001 5.93339C6.45948 6.2841 6.00095 6.67771 5.5798 7.1096C5.10055 7.59655 4.66271 8.12276 4.27084 8.68274C3.36927 9.96323 2.72989 11.4101 2.38965 12.9398C2.38324 12.9702 2.3774 13.0017 2.37099 13.0327C2.34474 13.1561 2.22574 13.7839 2.20941 13.9184C2.20941 13.9289 2.20941 13.9084 2.20941 13.9184C2.10019 14.5671 2.03026 15.2219 2 15.8791V15.951C2 23.7097 8.27646 30 16.0182 30C22.9521 30 28.7088 24.9549 29.8364 18.328C29.8597 18.1485 29.8789 17.9673 29.8999 17.786C30.1788 15.3763 29.869 12.8439 28.9905 10.7265ZM27.5999 11.4479V11.4631V11.4479Z"
      fill="url(#paint11_linear_1334_628)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1334_628"
        x1="27.135"
        y1="5.49261"
        x2="3.81392"
        y2="27.9437"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="#FFF44F" />
        <stop offset="0.11" stopColor="#FFE847" />
        <stop offset="0.22" stopColor="#FFC830" />
        <stop offset="0.37" stopColor="#FF980E" />
        <stop offset="0.4" stopColor="#FF8B16" />
        <stop offset="0.46" stopColor="#FF672A" />
        <stop offset="0.53" stopColor="#FF3647" />
        <stop offset="0.7" stopColor="#E31587" />
      </linearGradient>
      <radialGradient
        id="paint1_radial_1334_628"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(26.0596 4.21879) scale(29.2246 29.2888)"
      >
        <stop offset="0.13" stopColor="#FFBD4F" />
        <stop offset="0.19" stopColor="#FFAC31" />
        <stop offset="0.25" stopColor="#FF9D17" />
        <stop offset="0.28" stopColor="#FF980E" />
        <stop offset="0.4" stopColor="#FF563B" />
        <stop offset="0.47" stopColor="#FF3750" />
        <stop offset="0.71" stopColor="#F5156C" />
        <stop offset="0.78" stopColor="#EB0878" />
        <stop offset="0.86" stopColor="#E50080" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_1334_628"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(15.3809 16.1925) scale(29.2246 29.2888)"
      >
        <stop offset="0.3" stopColor="#960E18" />
        <stop offset="0.35" stopColor="#B11927" stopOpacity="0.74" />
        <stop offset="0.43" stopColor="#DB293D" stopOpacity="0.34" />
        <stop offset="0.5" stopColor="#F5334B" stopOpacity="0.09" />
        <stop offset="0.53" stopColor="#FF3750" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_1334_628"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(18.904 -2.42803) scale(21.172 21.2184)"
      >
        <stop offset="0.13" stopColor="#FFF44F" />
        <stop offset="0.25" stopColor="#FFDC3E" />
        <stop offset="0.51" stopColor="#FF9D12" />
        <stop offset="0.53" stopColor="#FF980E" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_1334_628"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(12.1477 23.8431) scale(13.915 13.9455)"
      >
        <stop offset="0.35" stopColor="#3A8EE6" />
        <stop offset="0.47" stopColor="#5C79F0" />
        <stop offset="0.67" stopColor="#9059FF" />
        <stop offset="1" stopColor="#C139E6" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_1334_628"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(15.7996 12.7116) rotate(-13.9265) scale(7.37316 8.67852)"
      >
        <stop offset="0.21" stopColor="#9059FF" stopOpacity="0" />
        <stop offset="0.28" stopColor="#8C4FF3" stopOpacity="0.06" />
        <stop offset="0.75" stopColor="#7716A8" stopOpacity="0.45" />
        <stop offset="0.97" stopColor="#6E008B" stopOpacity="0.6" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_1334_628"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(15.012 3.02041) scale(10.0108 10.0328)"
      >
        <stop stopColor="#FFE226" />
        <stop offset="0.12" stopColor="#FFDB27" />
        <stop offset="0.3" stopColor="#FFC82A" />
        <stop offset="0.5" stopColor="#FFA930" />
        <stop offset="0.73" stopColor="#FF7E37" />
        <stop offset="0.79" stopColor="#FF7139" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_1334_628"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(22.8815 -3.34294) scale(42.7109 42.8046)"
      >
        <stop offset="0.11" stopColor="#FFF44F" />
        <stop offset="0.46" stopColor="#FF980E" />
        <stop offset="0.62" stopColor="#FF5634" />
        <stop offset="0.72" stopColor="#FF3647" />
        <stop offset="0.9" stopColor="#E31587" />
      </radialGradient>
      <radialGradient
        id="paint8_radial_1334_628"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(18.7517 1.33374) rotate(84.2447) scale(31.1996 20.4543)"
      >
        <stop stopColor="#FFF44F" />
        <stop offset="0.06" stopColor="#FFE847" />
        <stop offset="0.17" stopColor="#FFC830" />
        <stop offset="0.3" stopColor="#FF980E" />
        <stop offset="0.36" stopColor="#FF8B16" />
        <stop offset="0.45" stopColor="#FF672A" />
        <stop offset="0.57" stopColor="#FF3647" />
        <stop offset="0.74" stopColor="#E31587" />
      </radialGradient>
      <radialGradient
        id="paint9_radial_1334_628"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(14.7757 6.73605) scale(26.6644 26.723)"
      >
        <stop offset="0.14" stopColor="#FFF44F" />
        <stop offset="0.48" stopColor="#FF980E" />
        <stop offset="0.59" stopColor="#FF5634" />
        <stop offset="0.66" stopColor="#FF3647" />
        <stop offset="0.9" stopColor="#E31587" />
      </radialGradient>
      <radialGradient
        id="paint10_radial_1334_628"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(21.8145 8.30047) scale(29.1844 29.2484)"
      >
        <stop offset="0.09" stopColor="#FFF44F" />
        <stop offset="0.23" stopColor="#FFE141" />
        <stop offset="0.51" stopColor="#FFAF1E" />
        <stop offset="0.63" stopColor="#FF980E" />
      </radialGradient>
      <linearGradient
        id="paint11_linear_1334_628"
        x1="26.855"
        y1="5.37218"
        x2="7.01043"
        y2="25.1739"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.17" stopColor="#FFF44F" stopOpacity="0.8" />
        <stop offset="0.27" stopColor="#FFF44F" stopOpacity="0.63" />
        <stop offset="0.49" stopColor="#FFF44F" stopOpacity="0.22" />
        <stop offset="0.6" stopColor="#FFF44F" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);
export default Firefox;
